export default "__VITE_ASSET__DIDQoDIP__"